/* eslint-disable no-unused-expressions */
import { errorCodes } from 'router5';
import { PAGE_NOT_FOUND_ROUTE, rootNamespace } from '../_constants';
export var redirectToNotFoundPlugin = function (router, dependencies) { return ({
    onTransitionError: function (toState, fromState, err) {
        var _a = dependencies, setModalAction = _a.setModalAction, store = _a.store, routes = _a.routes, i18nextConfig = _a.i18nextConfig;
        if ((err === null || err === void 0 ? void 0 : err.code) === errorCodes.ROUTE_NOT_FOUND) {
            var pageNotFound = routes === null || routes === void 0 ? void 0 : routes.find(function (_a) {
                var name = _a.name;
                return name === PAGE_NOT_FOUND_ROUTE;
            });
            if (pageNotFound) {
                router === null || router === void 0 ? void 0 : router.navigate(PAGE_NOT_FOUND_ROUTE);
                return;
            }
            var routerOptions = router === null || router === void 0 ? void 0 : router.getOptions();
            if (routerOptions === null || routerOptions === void 0 ? void 0 : routerOptions.defaultRoute) {
                router === null || router === void 0 ? void 0 : router.navigateToDefault();
                return;
            }
            if (setModalAction) {
                var translatedText = i18nextConfig === null || i18nextConfig === void 0 ? void 0 : i18nextConfig.i18next.t(rootNamespace + ":page-not-found");
                var text = translatedText && translatedText !== 'page-not-found'
                    ? 'Page not found.'
                    : 'Page not found.';
                store.dispatch(setModalAction({
                    status: 'error',
                    text: text,
                }));
            }
        }
    },
}); };
